export default function removeYour(value: string /*, hash*/): string {
  if (value.match(/^your /i) !== null) {
    const words = value.split(' ');
    words.shift();
    value = words.join(' ');
  }
  return value;
}
